import React from "react";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import "./AppDownloadLinks.css";

export default function AppDownloadLinks() {
    return (
        <section className="app-download-links" dir="rtl" aria-label="הורדת אפליקציית Blue PARC">
            <p className="app-download-links__title">הורידו את אפליקציית <bdi>Blue PARC</bdi></p>
            <div className="app-download-links__stores">
                <a
                    className="app-download-links__store"
                    href="https://play.google.com/store/apps/details?id=cloud.blueparking.invitefriend"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="הורדת Blue PARC מ־Google Play (נפתח בחלון חדש)"
                >
                    <AndroidIcon aria-hidden="true" />
                    <span>Google Play</span>
                </a>
                <a
                    className="app-download-links__store"
                    href="https://apps.apple.com/app/id6796329831"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="הורדת Blue PARC מה־App Store (נפתח בחלון חדש)"
                >
                    <AppleIcon aria-hidden="true" />
                    <span>App Store</span>
                </a>
            </div>
        </section>
    );
}
